<template>
  <div>
    <swiper class="swiperDefault" :options="swiperOption" v-if="showSwiper">
      <swiper-slide class="swiper-slide" v-for="(item, index) in imglist">
        <div class="slide-img">
          <img v-bind:src="item.img" />
          <p class="img-caption">{{ item.caption }}</p>
        </div>
      </swiper-slide>
    </swiper>

    <div class="swiper-button-prev" slot="button-prev">
      <i class="icon-arrow-down"></i>
    </div>
    <div class="swiper-button-next" slot="button-next">
      <i class="icon-arrow-down"></i>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      totalRows: 0,
      jobFunctions: [],
      showSwiper: false,
      swiperOption: {
        autoplay: {
          delay: 3000,
          disableOnInteraction: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  computed: {
    innerwidth() {
      return this.$store.state.innerWidth;
    },
  },
  watch: {
    innerwidth(news, old) {
      this.showSwiper = false;
      this.setWidth();
    },
  },
  props: { imglist: null },
  methods: {
    init: function () {},
    setWidth: function () {
      var that = this;
			this.showSwiper = false;
      this.$nextTick(() => {
        this.showSwiper = true;
      });
    },
  },
  mounted() {
    var that = this;
    var mySwiper;
    setTimeout(function () {
      that.setWidth();
    }, 200);
  },
};
</script>